module.exports = __webpack_public_path__ + "ce60aebed3dc7568f95baef743f2b495.svg";